import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  // Keep the descriptor unchanged so existing loading translations retain their ID.
  loading: {
    defaultMessage: 'Loading…',
    description: 'Dropdown loading message',
  },
  cancel: {
    defaultMessage: 'Cancel',
    description: 'Button that abandons an action without applying it',
  },
  close: {
    defaultMessage: 'Close',
    description: 'Button that dismisses a dialog or message',
  },
  complete: {
    defaultMessage: 'Complete',
    description: 'Status label for work that has finished',
  },
  error: {
    defaultMessage: 'Error',
    description: 'Status label for work that stopped because something failed',
  },
  inProgress: {
    defaultMessage: 'In progress',
    description: 'Status label for work that has started but is not finished',
  },
  done: {
    defaultMessage: 'Done',
    description: 'Button that acknowledges a finished action and dismisses it',
  },
  incomplete: {
    defaultMessage: 'Incomplete',
    description: 'Status label for work that has not been started',
  },
  pendingAction: {
    defaultMessage: 'Pending action',
    description: 'Status label for work that is held until someone acts on it',
  },
  remote: {
    defaultMessage: 'Remote',
    description:
      'Label used in place of a physical location when a role or location is remote',
  },
  waiting: {
    defaultMessage: 'Waiting',
    description: 'Status label for work that is queued but not started',
  },
});

export default messages;
